import { DayPicker, type DateRange, type Matcher } from 'react-day-picker';
import { tv } from 'tailwind-variants';
import type { Locale } from 'date-fns';

type Props = {
  selected: DateRange | undefined;
  onSelect: (date: DateRange | undefined) => void;
  month: Date;
  onMonthChange: (month: Date) => void;
  locale: Locale;
  disabled?: Matcher;
};

const classes = tv({
  slots: {
    day: 'h-[4.8rem] text-primary headline4',
    weekday: 'h-[4.2rem] text-secondary p5 uppercase',
    today: 'text-primary',
    range_middle: 'bg-secondary-bg text-foreground',
    selected: 'border-none',
    outside: '!text-secondary !opacity-100',
    disabled: 'text-secondary !opacity-100',
  },
});

function RangePicker({
  selected,
  onSelect,
  month,
  onMonthChange,
  locale,
  disabled,
}: Props) {
  const c = classes();

  return (
    <DayPicker
      mode="range"
      selected={selected}
      onSelect={onSelect}
      month={month}
      onMonthChange={onMonthChange}
      locale={locale}
      disabled={disabled}
      components={{
        CaptionLabel: () => <></>,
        MonthCaption: () => <></>,
        NextMonthButton: () => <></>,
        PreviousMonthButton: () => <></>,
      }}
      showOutsideDays
      fixedWeeks
      classNames={{
        day: c.day(),
        weekday: c.weekday(),
        today: c.today(),
        range_middle: c.range_middle(),
        selected: c.selected(),
      }}
      modifiersClassNames={{
        outside: c.outside(),
        disabled: c.disabled(),
      }}
    />
  );
}

export { RangePicker };
